import { useState } from "react";

type Props = {
  src: string;
  alt: string;
  name: string;
  role: string;
};

/** 人物写真。画像が未設置・読込失敗時はシルエットのプレースホルダーを表示する */
export default function PortraitImage({ src, alt, name, role }: Props) {
  const [failed, setFailed] = useState(false);

  return (
    <figure className="w-full">
      <div className="aspect-[4/5] w-full overflow-hidden bg-background-200">
        {failed ? (
          <div className="flex h-full w-full items-end justify-center bg-gradient-to-b from-background-200 to-background-300">
            <i className="ri-user-3-fill text-[180px] leading-none text-background-50/80 md:text-[220px]" />
          </div>
        ) : (
          <img
            src={src}
            alt={alt}
            onError={() => setFailed(true)}
            className="h-full w-full object-cover object-top"
          />
        )}
      </div>
      <figcaption className="mt-4 flex items-baseline justify-between gap-4">
        <span className="font-heading text-lg tracking-[0.06em] text-foreground-950">{name}</span>
        <span className="font-label text-xs tracking-[0.24em] text-secondary-500">{role}</span>
      </figcaption>
    </figure>
  );
}
